/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { NEGOTIABLE_QUOTE_LIST_FRAGMENT } from '@/quote-management/api/graphql/NegotiableQuoteListFragment';
import { SEARCH_RESULT_PAGE_INFO_FRAGMENT } from '@/quote-management/api/graphql/SearchResultPageInfoFragment';
import { SORT_FIELDS_FRAGMENT } from '@/quote-management/api/graphql/SortFieldsFragment';

export const NEGOTIABLE_QUOTES_QUERY = /* GraphQL */ `
  query negotiableQuotes(
    $filter: NegotiableQuoteFilterInput
    $pageSize: Int
    $currentPage: Int
    $sort: NegotiableQuoteSortInput
  ) {
    negotiableQuotes(
      filter: $filter
      pageSize: $pageSize
      currentPage: $currentPage
      sort: $sort
    ) {
      items {
        ...NegotiableQuoteListFragment
      }
      page_info {
        ...SearchResultPageInfoFragment
      }
      sort_fields {
        ...SortFieldsFragment
      }
      total_count
    }
  }

  ${NEGOTIABLE_QUOTE_LIST_FRAGMENT}
  ${SEARCH_RESULT_PAGE_INFO_FRAGMENT}
  ${SORT_FIELDS_FRAGMENT}
`;
